export default __webpack_public_path__ + "static/media/ARSHAGROVERMAKEUP.5cc2e7d6.png";